import React, { useCallback } from 'react';
import Link from 'next/link';
import classNames from 'classnames';
import Map from '@/components/Map';
import Div from '@/shared/Div';
import { getBlogCategoryURL } from '@/utils/urls';

interface tabItem {
  label: string;
  id: number;
  blogTypeId: string;
}

interface tabProps {
  className?: string;
  tabItems: tabItem[];
  activeClassNames: string;
  setActiveTab: (tab: string) => void;
  activeTab: string;
  label?: string;
}

export const Categories = (props: tabProps) => {
  const { tabItems, activeClassNames, setActiveTab, activeTab, className } = props;

  const handleItemClick = (name: string) => {
    setActiveTab(name);
  };

  const renderCategories = useCallback(
    (item: tabItem, index: number) => {
      const isActive = activeTab === item.blogTypeId;
      const href = getBlogCategoryURL(item.blogTypeId);
      return (
        <Div
          data-testid={`${isActive ? 'active-' : ''}${index}-${item.blogTypeId}`}
          className={classNames(
            'border-b-2 pb-s3 md:pb-s2 text-body-xl md:text-body-2xl flex items-center justify-center md:min-w-[120px]',
            {
              'border-transparent font-normal': !isActive,
              [`${activeClassNames}`]: isActive,
            },
          )}
          onClick={() => handleItemClick(item.blogTypeId)}
          key={`${index}-${item.blogTypeId}`}
        >
          <Link href={href}>{item.label}</Link>
        </Div>
      );
    },
    [activeTab, activeClassNames],
  );

  return <Map className={className} list={tabItems || []} render={renderCategories} />;
};
